// stub: Radar 监控 SDK no-op
class Radar {
    constructor(_options) {}
    init() { return this; }
    report() {}
    setUser() {}
    setExtraInfo() {}
}
const noop = () => {};
Radar.init = noop;
Radar.report = noop;
module.exports = Radar;
module.exports.default = Radar;
